import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../main/main.styles';

export const BuyerAnalyticsStyles = css`
  ${MainStyles}
  :host {
    display: contents;
  }
`;
